import { Button, Group, Paper, Title } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import type { JSX, ReactNode } from 'react';

export interface SettingsSectionProps {
  title: string;
  editing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  saving: boolean;
  children: ReactNode;
  /**
   * Optional override for the right-side action area. When provided,
   * replaces the default Edit / Save / Cancel buttons. Used by sections
   * with non-standard controls (e.g. PaymentSection's "Show Details" + "Edit via Stripe").
   * Pass null to render no actions.
   */
  actions?: ReactNode;
}

export function SettingsSection({
  title,
  editing,
  onEdit,
  onSave,
  onCancel,
  saving,
  children,
  actions,
}: SettingsSectionProps): JSX.Element {
  let header: ReactNode;
  if (actions !== undefined) {
    header = actions;
  } else if (editing) {
    header = (
      <Group gap="xs">
        <Button variant="default" size="xs" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button size="xs" onClick={onSave} loading={saving}>
          Save
        </Button>
      </Group>
    );
  } else {
    header = (
      <Button variant="subtle" size="xs" leftSection={<IconEdit size={14} />} onClick={onEdit}>
        Edit
      </Button>
    );
  }
  return (
    <Paper withBorder p="lg" radius="md">
      <Group justify="space-between" mb="md">
        <Title order={3}>{title}</Title>
        {header}
      </Group>
      {children}
    </Paper>
  );
}
